(function (root) {
  'use strict';
  function nextPosition(position, offsets, direction) {
    if (direction > 0) return offsets.find(offset => offset > position + 1) ?? position;
    return offsets.slice().reverse().find(offset => offset < position - 1) ?? position;
  }
  function normalizePosition(position, cycleWidth) {
    if (cycleWidth <= 0) return position;
    return cycleWidth + ((position - cycleWidth) % cycleWidth + cycleWidth) % cycleWidth;
  }
  function initialize(element) {
    if (!element || element.inextCarousel) return;
    const track = element.querySelector('.carousel-inner');
    if (!track) return;
    const originals = Array.from(track.children);
    if (originals.length < 2) return;
    const state = { cycleWidth: 0, timer: null };
    element.inextCarousel = state;
    function cloneCard(card) {
      const clone = card.cloneNode(true);
      clone.dataset.carouselClone = 'true';
      clone.setAttribute('aria-hidden', 'true');
      clone.setAttribute('tabindex', '-1');
      clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
      return clone;
    }
    function rebuild() {
      const oldWidth = state.cycleWidth;
      const phase = oldWidth ? (normalizePosition(element.scrollLeft, oldWidth) - oldWidth) / oldWidth : 0;
      track.querySelectorAll('[data-carousel-clone]').forEach(card => card.remove());
      state.cycleWidth = 0;
      const width = originals.reduce((sum, card) => sum + card.getBoundingClientRect().width, 0);
      if (width <= element.clientWidth || !width) {
        element.scrollTo({ left: 0, behavior: 'instant' });
        return;
      }
      const before = document.createDocumentFragment();
      const after = document.createDocumentFragment();
      originals.forEach(card => { before.appendChild(cloneCard(card)); after.appendChild(cloneCard(card)); });
      track.insertBefore(before, originals[0]);
      track.appendChild(after);
      state.cycleWidth = originals[0].offsetLeft - track.firstElementChild.offsetLeft;
      element.scrollTo({ left: state.cycleWidth * (1 + phase), behavior: 'instant' });
    }
    function recenter() {
      if (!state.cycleWidth) return;
      const target = normalizePosition(element.scrollLeft, state.cycleWidth);
      if (Math.abs(target - element.scrollLeft) > 1) element.scrollTo({ left: target, behavior: 'instant' });
    }
    element.addEventListener('scroll', function () {
      clearTimeout(state.timer);
      state.timer = setTimeout(recenter, 180);
    }, { passive: true });
    element.addEventListener('scrollend', recenter);
    state.move = function (amount) {
      if (!state.cycleWidth) return;
      const origin = track.firstElementChild.offsetLeft;
      const offsets = Array.from(track.children).map(card => card.offsetLeft - origin);
      const target = nextPosition(element.scrollLeft, offsets, Math.sign(amount));
      const reducedMotion = root.matchMedia('(prefers-reduced-motion: reduce)').matches;
      element.scrollTo({ left: target, behavior: reducedMotion ? 'instant' : 'smooth' });
    };
    rebuild();
    if (root.ResizeObserver) {
      const observer = new root.ResizeObserver(rebuild);
      observer.observe(element);
      originals.forEach(card => observer.observe(card));
    }
  }
  function scroll(element, amount) {
    initialize(element);
    if (element && element.inextCarousel) element.inextCarousel.move(amount);
  }
  const api = { nextPosition, normalizePosition, initialize, scroll };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (root.document) {
    root.InextProductCarousel = api;
    const setup = () => root.document.querySelectorAll('#topCarousel').forEach(initialize);
    if (root.document.readyState === 'loading') root.document.addEventListener('DOMContentLoaded', setup);
    else setup();
    root.document.addEventListener('shopify:section:load', setup);
  }
})(typeof window !== 'undefined' ? window : globalThis);
